jQuery(function ($) {
    var target = document.querySelector('#sbi_images');
    if (target === null) {
        return;
    }
    $('#sbi_images').addClass('owl-carousel');
    $('.sbi_item').addClass('item');
    $('.sbi_item').css('width', '100%');
    $('.owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        }
    });
});
